import { v4 as uuidv4 } from 'uuid';
import { getCancellationServiceApiUrl } from '../selectors/selectors';
import { APPLICATION_JSON, CLIENT_ID } from '../constants/constants';

export default {
  fetch: ({
    email, envConfig, locale, correlationId,
  }, action, state) => ({
    url: `${getCancellationServiceApiUrl(state)}/flight/authorize`,
    opts: {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: APPLICATION_JSON,
        'Content-Type': 'application/json',
        'x-client-id': CLIENT_ID,
        'x-correlation-id': correlationId || uuidv4(),
        'x-locale': locale,
        'x-user-agent': window.navigator.userAgent,
        'x-timestamp': new Date().toISOString(),
        'x-tulips-env': envConfig?.['x-tulips-env'],
      },
      body: JSON.stringify({
        email,
      }),
    },
  }),
};
